<template>
    <div class="Filters">
        <h5>Filter</h5>
        <div class="Filters__row">
            <!--<ReviewsFilter />-->
            <!--<LocationsFilter />-->
            <RPDateFilter v-model="dates" />
        </div>
        <h5>Sort</h5>
        <div class="Filters__row">
            <RPReviewSort v-model="temp" />
        </div>
        <h5>Misc</h5>
        <div class="Filters__row">
            <RPExportButton />
        </div>
    </div>
</template>
<script>
// import ReviewsFilter from 'components/Complex/Filters/ReviewsFilter.vue'
// import LocationsFilter from 'components/Complex/Filters/LocationsFilter.vue'
import RPDateFilter from 'components/Complex/Filters/DateFilter/RPDateFilter.vue';
import RPExportButton from 'components/Complex/Misc/RPExportButton.vue';
import RPReviewSort from 'components/Complex/Sorts/RPReviewSort.vue';

export default {
    name: 'Filters',
    components: {
        // ReviewsFilter,
        // LocationsFilter,
        RPExportButton,
        RPReviewSort,
        RPDateFilter
    },
    data(){
        return {
            temp: '',
            dates: {}
        };
    }
};
</script>
<style lang="scss">
    .Filters {
        background: #F6F8F9;
        padding: 50px;
        width: 100%;
        height: 300%;

        h5 {
            margin-bottom: 1rem;
        }

        &__row {
            width: 100%;
            display: flex;
            justify-content: space-around;
            & > * {
                margin: 0 25px 25px 0;
            }
        }
    }
</style>
